import React, {Component} from 'react';
import { RTLTable,RTLCol,RTLButton } from '../RTLKit';
import {Divider, Row, Form} from 'antd';
import {Field, reduxForm} from "redux-form";
import moment from "jalali-moment";
import TextField from "../formFields/TextField";
import DatePickerField from "../formFields/DatePickerField";
import {CSVLink} from "react-csv";
import SelectField from "../formFields/SelectField";

const columns = [
    {
        title: 'ردیف',
        dataIndex: 'key',
        label: 'ردیف',
        key: 'key',
        sorter: (a, b) => a.key - b.key,
    },
    {
        title: 'تاریخ',
        dataIndex: 'finished_at',
        label: 'تاریخ',
        key: 'finished_at',
    },
    {
        title: 'شماره درخواست',
        dataIndex: 'order_system_code',
        label: 'شماره درخواست',
        key: 'order_system_code',
    },
    {
        title: 'مبلغ',
        dataIndex: 'pos',
        label: 'مبلغ',
        key: 'pos',
        className:"price"
    },
  ];


class Pos extends Component {

    constructor(props) {
        super(props);
        this.state = {
            role:'',
            searchBoxHidden:true, //hidden=true
            loading:true,
            pageSize:10,
            current: (this.props.list ? this.props.list.pageNumber : 1)
        }
    }

    componentWillMount() {
    }

    /*--- pagination ---*/
    handlePageChange(pageNumber) {
        this.setState({current: pageNumber});
        this.props.getList({page:pageNumber});
    }

    /*--- fix user list for show in table ---*/
    __fixListForShowInTable() {
        var list = this.props.list;
        var dataSource = [];

        if(list) {
            for (let i = 0; i < list.length; i++) {

                dataSource.push({
                    key: i+1,
                    finished_at       : list[i].FINISHED_AT ? moment(list[i].FINISHED_AT).format('jYYYY/jM/jD') : '',
                    order_system_code : list[i].ORDER_SYSTEM_CODE,
                    pos               : list[i].POS,
                });
            }
        }
        return dataSource;
    }

    __toggleSearchBox(){
        this.setState({
            searchBoxHidden : !this.state.searchBoxHidden
        })
    }

    __onChangeCounter(value) {
        this.setState({
            pageSize:value
        })
    }

    /*-- search form ---*/
    onFormSubmit(value) {
        this.props.handleSubmit(value);
    }

    __clearFilter() {
        this.props.reset();
        this.props.getList()
    }

    __goBack(){
        this.props.history.goBack()
    }

    render() {
        var _self = this;
        const {pageSize,searchBoxHidden } = this.state;
        const { list } = this.props;
        var data = this.__fixListForShowInTable()

        return (
            <div>
                <Row type="flex">
                    <RTLCol xs={24} md={18}>
                        <Divider orientation="left">گزارش کارتخوان</Divider>
                    </RTLCol>
                    <RTLCol xs={24} md={6} >
                        <RTLButton type="primary" className="userListBtn" shape="round" icon="search" onClick={this.__toggleSearchBox.bind(this)} ></RTLButton>
                        {data.length > 0 ?
                            <RTLButton type="primary" className="userListBtn" shape="round" >
                                <CSVLink
                                    data={data}
                                    headers={columns}
                                    className='export-link'
                                    filename={"report_pos.csv"}
                                    target="_blank"
                                >
                                    خروجی اکسل
                                </CSVLink>
                            </RTLButton>
                            : null}
                    </RTLCol>
                </Row>
                <Row>
                    <Form name="search" onSubmit={this.onFormSubmit.bind(this)} className="login-form">
                        <Row gutter={4} type="flex" justify="start" align="top" hidden={searchBoxHidden} >
                            <RTLCol sm={12} md={4}>
                                <Field
                                    name="pos"
                                    component={TextField}
                                    placeholder="شماره پایانه"
                                />
                            </RTLCol>
                            <RTLCol sm={12} md={4}>
                                <Field
                                    name="settlement_date"
                                    component={SelectField}
                                    placeholder="وضعیت گزارش"
                                    list={[
                                        {label: 'تاریخ ایجاد', value: 'true', key: 1},
                                        {label: 'تاریخ تسویه', value: 'false', key: 2}
                                    ]}
                                    onChange={(customer_settle) => {
                                        this.setState(prevState  => ({
                                            filter: {...prevState.filter,customer_settle:customer_settle}
                                        }))
                                    }}
                                />
                            </RTLCol>
                            <RTLCol sm={12} md={4}>
                                <Field
                                    name="created_from"
                                    component={DatePickerField}
                                    placeholder="ار تاریخ"
                                    timePicker={false}
                                />
                            </RTLCol>
                            <RTLCol sm={12} md={4}>
                                <Field
                                    name="created_to"
                                    component={DatePickerField}
                                    placeholder="تا تاریخ"
                                    timePicker={false}
                                />
                            </RTLCol>
                            <RTLCol sm={24} md={2}>
                                <RTLButton className="left" type="default" shape="round" onClick={this.__clearFilter.bind(this)}>
                                    بروزرسانی
                                </RTLButton>
                            </RTLCol>
                            <RTLCol sm={24} md={2}>
                                <RTLButton loading={this.props.common.isProgressing} className="left" type="primary" shape="round" htmlType="submit">
                                    جستجو
                                </RTLButton>
                            </RTLCol>
                        </Row>
                    </Form>
                </Row>
                <Row>
                    <RTLTable rowClassName={(record, index) => (index+1)%2 == 0 ? 'even' : 'odd' } className={'reportTable'}
                              pagination={false} columns={columns}
                              dataSource={this.__fixListForShowInTable()} size="small" />
                </Row>
                <RTLButton onClick={this.__goBack.bind(this)} className="backBtn2" type="default" >
                    بازگشت
                </RTLButton>
            </div>
        );
    }
}

export default Pos = reduxForm({
    form: 'list'
})(Pos)
